module.exports = __webpack_public_path__ + "static/media/illustrations-build-feed.dc74d535.svg";